import {createAction} from "redux-actions";

export const didReceiveSpecial = createAction('RECEIVE_SPECIAL');
export const clearSpecial = createAction('CLEAR_SPECIAL');

export const didReceiveSpecials = createAction('RECEIVE_SPECIALS');
export const clearSpecials = createAction('CLEAR_SPECIALS');

export const requestFailed = createAction("REQUEST_FAILED");
export const requestStarted = createAction("REQUEST_STARTED");
export const requestSucceeded = createAction("REQUEST_SUCCEEDED");


// WEBPACK FOOTER //
// ./app/client/special/actions.ts